const renderPlayer = (el, fileHash) => {
  if (!el) return;
  el.forEach($music => {
    let id = $music.dataset.mp3Id;
    let file = fileHash[id];
    import("aplayer").then(module => {
      const Aplayer = module.default;
      new Aplayer({
        container: document.getElementById(`editor-mp3-${file.id}`),
        audio: [
          {
            name: file.id3.title || "",
            artist: file.id3.artist || "",
            url: file.url,
            cover:
              (file.id3.cover && "data:image/jpeg;base64," + file.id3.cover) ||
              ""
          }
        ]
      });
    });
  });
};
export default renderPlayer;
